import React, { useEffect, useState } from "react";
import { auth, database } from "../../Config/firebase"; // Ruta correcta si el archivo se llama firebase.js
import { ref, onValue } from "../../Config/matuRtdb"; // Usamos onValue para escuchar en tiempo real
import VIPBanner from "./VIPBanner";

export default function FreePay() {
  const [userType, setUserType] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const currentUser = auth.currentUser;

    // Si no hay usuario logueado, mostrar directamente el banner
    if (!currentUser) {
      setUserType("guest");
      return;
    }

    // Solo activar loading si hay usuario logueado
    setLoading(true);
    
    const userRef = ref(database, "usuarios/" + currentUser.uid);

    const unsubscribe = onValue(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.val();
        if (userData && userData.typeU === "Cuenta Vip") {
          setUserType("vip");
        } else {
          setUserType("normal");
        }
      } else {
        // Si el usuario está logueado pero no tiene datos en la BD, mostrar banner
        console.log("Usuario logueado pero sin datos en BD, mostrando banner");
        setUserType("normal");
      }
      setLoading(false);
    }, (error) => {
      console.error("Error al obtener datos del usuario:", error);
      // Si hay error, tratar como usuario normal y mostrar banner
      setUserType("normal");
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Si es usuario VIP, no mostrar nada
  if (userType === "vip") {
    return null;
  }

  // Si está cargando (solo para usuarios logueados)
  if (loading) {
    return (
      <div className="mb-6 max-w-md mx-auto">
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-4 border border-gray-600/30">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
            <span className="ml-2 text-gray-300">Verificando cuenta...</span>
          </div>
        </div>
      </div>
    );
  }

  // Mostrar banner para usuarios normales o invitados
  return (
    <div className="mb-6 max-w-md mx-auto">
      <VIPBanner />
    </div>
  );
}
